// Source: app/scripts/services/auction.js
Auction.factory('Auction', ['$resource', function ($resource) {
  return $resource('/data/rest/auctions/:id', {}, {
    'publish': {
      method: 'POST',
      url: '/data/rest/auctions/publish'
    },
    'saveAuctionDetails': {
      method: 'POST',
      url: '/data/rest/auctions/details'
    },
    'loadDetails': {
      method: 'GET',
      url: '/data/rest/auctions/:id/details'
    },
    'history': {
      method: 'GET',
      url: '/data/rest/auctions/history',
      isArray: true
    },
    'getLots': {
      method: 'GET',
      url: '/data/rest/auctions/:id/lots',
      isArray: true
    },
    'getRequests': {
      method: 'GET',
      url: '/data/rest/auctions/:id/requests',
      isArray: true
    },
    'getProducts': {
      method: 'GET',
      url: '/data/rest/auctions/:id/products',
      isArray: true
    },
    'addLots': {
      method: 'POST',
      url: '/data/rest/auctions/add_lots'
    },
    'removeLot': {
      method: 'POST',
      url: '/data/rest/auctions/remove_lot'
    },
    'getAnnouncement': {
      method: 'GET',
      url: '/data/rest/auctions/:id/last_announcement'
    },
    'getPreviousAnnouncement': {
      method: 'GET',
      isArray: true,
      url: '/data/rest/auctions/:id/previous_announcement'
    },
    getLog: {
      method: 'GET',
      url: '/data/rest/auctions/log',
      isArray: true
    },
    close: {
      method: 'POST',
      url: '/data/rest/auctions/close'
    },
    cancel: {
      method: 'POST',
      url: '/data/rest/auctions/cancel'
    },
    postpone: {
      method: 'POST',
      url: '/data/rest/auctions/postpone'
    },
    duplicate: {
      method: 'POST',
      url: '/data/rest/auctions/duplicate'
    },
    findDuplicates: {
      method: 'GET',
      url: '/data/rest/auctions/duplicates',
      isArray: true
    },
    'getFailedAuctionLots': {
      method: 'GET',
      url: '/data/rest/auctions/:id/failedlots',
      isArray: true
    },
    getOutcome: {
      method: 'GET',
      url: '/data/rest/auctions/:id/outcome',
      isArray: true
    },
    getBids: {
      method: 'GET',
      url: '/data/rest/auctions/bids/:auctionId/:lotId',
      isArray: true
    },
    forceFinish: {
      method: 'POST',
      url: '/data/rest/auctions/force_finish',
      isArray: false
    },
    setLotPart: {
      method: 'POST',
      url: '/data/rest/auctions/add_lot_part'
    },
    getLotPart: {
      method: 'GET',
      url: '/data/rest/lot_part_in_auction/get_lot_part_for_auction_and_lot'
    }
  });
}]);


Auction.factory('Lot', ['$resource', function ($resource) {
  return $resource('/data/rest/lots/:id', {}, {
    'history': {
      method: 'GET',
      url: '/data/rest/lots/history',
      isArray: true
    },
    'getProducts': {
      method: 'GET',
      url: '/data/rest/lots/:id/products',
      isArray: true
    },
    'addProducts': {
      method: 'POST',
      url: '/data/rest/lots/add_products'
    },
    'removeProduct': {
      method: 'POST',
      url: '/data/rest/lots/remove_product'
    },
    'getLicenses': {
      method: 'GET',
      url: '/data/rest/lots/:id/licenses',
      isArray: true
    },
    'getLicensesTypes': {
      method: 'GET',
      url: '/data/rest/lots/:id/licensetypes',
      isArray: true
    },
    'addLicenceTypes': {
      method: 'POST',
      url: '/data/rest/lots/add_license_types'
    },
    'removeLicenceType': {
      method: 'DELETE',
      url: '/data/rest/lots/remove_license_type/:id'
    },
    getLog: {
      method: 'GET',
      url: '/data/rest/lots/log',
      isArray: true
    },
    close: {
      method: 'POST',
      url: '/data/rest/lots/close'
    },
    cancel: {
      method: 'POST',
      url: '/data/rest/lots/cancel'
    },
    markPaid: {
      method: 'POST',
      url: '/data/rest/lots/markpaid'
    },
    enableEdit: {
      method: 'POST',
      url: '/data/rest/lots/enableedit'
    },
    secondWinner: {
      method: 'POST',
      url: '/data/rest/lots/secondwinner'
    },
    getCurrent: {
      method: 'GET',
      url: '/data/rest/lots/current'
    },
    findSecondWinners: {
      method: 'GET',
      url: '/data/rest/lots/secondwinners',
      isArray: true
    },
    getDto: {
      method: 'GET',
      url: '/data/rest/lots/dto'
    }
  });
}]);


Auction.factory('AuctionParticipationRequest', ['$resource', function ($resource) {
  return $resource('/data/rest/auction_participation_requests/:id', {}, {
    'approve': {
      method: 'POST',
      url: '/data/rest/auction_participation_requests/approve'
    },
    'reject': {
      method: 'POST',
      url: '/data/rest/auction_participation_requests/reject'
    },
    getLog: {
      method: 'GET',
      url: '/data/rest/auction_participation_requests/log',
      isArray: true
    },
    getUserDetails: {
      method: 'GET',
      url: '/data/rest/auction_participation_requests/userdetails'
    }, sendRequest: {
      method: 'POST',
      url: '/data/rest/auction_participation_requests/request'
    }, getLotRequest: {
      method: 'GET',
      url: '/data/rest/auction_participation_requests/lot/:id'
    },
    getMyRequests: {
      method: 'GET',
      url: '/data/rest/auction_participation_requests/my_requests',
      isArray: true
    },
    findAuctionRequestUsers: {
      method: 'GET',
      isArray: true,
      url: '/data/rest/auction_participation_requests/users'
    }
  });
}]);
